<script setup lang="ts">
import type { BeltColor } from '@@/bits/belt_colors'
import { ww } from '@@/bits/global'
import { useSettingsUserInfoStore } from '@@/pinia/settings_user_info'
import DashboardSettingsBeltProgressBeltCertificateContainer from '@@/vuecomponents/DashboardSettingsBeltProgressBeltCertificateContainer.vue'
import { ref } from 'vue'

// If we have vueStartingState, use it directly; otherwise fetch from store
const beltColor = ref<BeltColor>((ww.vueStartingState?.beltColor || 'yellow') as BeltColor)
const year = ref(ww.vueStartingState?.year || new Date().getFullYear())
const signatureName = ref(ww.vueStartingState?.signatureName || 'Linh Nguyen')
const signatureRole = ref(ww.vueStartingState?.signatureRole || 'Engineering Manager')
const signatureStamp = ref(ww.vueStartingState?.signatureStamp || '')
const certificateToken = ref(ww.vueStartingState?.certificateToken || '')
const certificateQrCode = ref(ww.vueStartingState?.certificateQrCode || '')

// Initialize user info store with data from vueStartingState
const settingsUserInfoStore = useSettingsUserInfoStore()
// settingsUserInfoStore.name = ww.vueStartingState?.userName || ''
settingsUserInfoStore.name = ww.vueStartingState?.name || ''
settingsUserInfoStore.username = ww.vueStartingState?.username || ''
settingsUserInfoStore.avatar = ww.vueStartingState?.avatar || ''
</script>

<template>
  <div id="certificate-container" class="relative h-screen" style="background-color: transparent">
    <!-- Use higher max scale for sharper screenshots -->
    <DashboardSettingsBeltProgressBeltCertificateContainer
      :signature-name="signatureName"
      :signature-role="signatureRole"
      :signature-stamp="signatureStamp"
      :certificate-token="certificateToken"
      :certificate-qr-code="certificateQrCode"
      :belt-color="beltColor"
      :year="year"
      :with-background-illustration="true"
      :is-dark-mode="false"
      :max-scale="2"
    />
  </div>
</template>

<style scoped>
/* Ensure the certificate is rendered at the correct size for screenshot */
#certificate-container {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
}
</style>
